module.exports = __webpack_public_path__ + "img/frame_123.242e0119.svg";